module.exports = __webpack_public_path__ + "static/media/success.170998a4.png";